import axios from 'axios';

// Create an Axios instance with base URL from environment variable
const API = axios.create({
  baseURL: import.meta.env.VITE_API_URL, // http://localhost:8000/api
  headers: {
    'Content-Type': 'application/json',
  },
});

// List of public endpoints that don't require authentication
const publicEndpoints = ['/auth/login'];

// Request interceptor to add auth token (skip for public endpoints)
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 errors globally (token refresh logic would go here)
    if (error.response?.status === 401) {
      // Clear expired tokens
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      
      // Redirect to login if not already there
      if (window.location.pathname !== '/auth/login') {
        window.location.href = '/auth/login';
      }
    }

    const errorMessage = error.response?.data?.message || 
                        error.response?.data?.detail || 
                        error.response?.data?.error || 
                        'An error occurred';
    
    return Promise.reject(new Error(errorMessage));
  }
);

export default API;